import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { MultiselectDropdown } from "app/pages/sales-intelligence/common-components/dropdown/MultiselectDropdown";

import { DD_POPUP_HEIGHT } from "./const";

type AdsSellersDropdownProps = {
    items: readonly string[];
    selectedItems: readonly string[];
    disabledItems: readonly string[];
    onSelect: (item: string) => void;
};

const AdsSellersDropdown = (props: AdsSellersDropdownProps) => {
    const { items, onSelect, selectedItems, disabledItems } = props;

    const dropdownItems = useMemo(
        () =>
            items.map((item) => ({
                id: item,
                text: item,
            })),
        [items],
    );
    return (
        <MultiselectDropdown
            elementId="ads-sellers-dropdown"
            onSelect={onSelect}
            selectedItems={selectedItems}
            disabledItems={disabledItems}
            items={dropdownItems}
            buttonText={translate("si.find_apps.filters.ads_sellers.modal.dd_placeholder")}
            searchPlaceHolder={translate("si.find_apps.filters.ads_sellers.modal.dd_placeholder")}
            hasSearch
            width="100%"
            dropdownPopupHeight={DD_POPUP_HEIGHT}
        />
    );
};

export default AdsSellersDropdown;
